import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shield, Loader2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SuperAdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API}/superadmin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        // sa_session_token is set as an httpOnly cookie by the backend — no client-side storage needed
        navigate("/superadmin/dashboard");
      } else {
        const err = await res.json();
        toast.error(err.detail || "Invalid credentials");
      }
    } catch {
      toast.error("Connection error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-red-500/20 flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-red-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Super Admin</h1>
          <p className="text-sm text-gray-500 mt-1">WarMap Platform Management</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-2">
            <Label className="text-gray-400">Email</Label>
            <Input
              data-testid="sa-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-white/5 border-white/10 text-white" placeholder="admin@example.com" required
            />
          </div>
          <div className="space-y-2">
            <Label className="text-gray-400">Password</Label>
            <Input
              data-testid="sa-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-white/5 border-white/10 text-white" placeholder="Master password" required
            />
          </div>
          <Button data-testid="sa-login-btn" type="submit" disabled={loading} className="w-full bg-red-600 hover:bg-red-700">
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Shield className="w-4 h-4 mr-2" />}
            Access Platform Admin
          </Button>
        </form>
      </div>
    </div>
  );
}
